import {needAuth} from "../instance/Instance";

export async function callLlm(uri, search) {
    try {
        const config = {
            ...(search && Object.keys(search).length > 0 ? { params: search } : {}),
            headers: {
                "X-Suppress-Global-Alert": "true",
            },
        };
        return await needAuth.get('/llm/summary', config);
    } catch (error) {
        return error;
    }
}

export async function callSSELlm(uri, search) {
    try {
        return await needAuth.get('/llm/'+uri+'/stream', {
            headers: {
                "X-Suppress-Global-Alert": "true",
            },
        });
    }catch (error){
        return error
    }
}
